import {
    TOGGLE_ALL_PRESENTATION,
    RESET_PRESENTATION_LIST,
    SET_PRESENTATION_LIST,
    TOGGLE_SELECT_PRESENTATION,
    TOGGLE_SELECT_RENDER_PRODUCT,
    RESET_SELECTED_RENDER_PRODUCT,
    UPDATE_SELECTED_RENDER_PRODUCT
  } from '../../constants/actionTypes';
  
  export const presentationModuleReducer = (
    state = {
      selectedPresentations: [],
      selectedRenderProducts: [],
      presentationsList: []
    },
    action
  ) => {
  
    switch (action.type) {
      case TOGGLE_SELECT_PRESENTATION:
        return applyToggleSelectPresentation(state, action);
      case TOGGLE_ALL_PRESENTATION:
        return applyToggleAllPresentations(state);
      case SET_PRESENTATION_LIST:
        return setPresentationList(state, action);
      case RESET_PRESENTATION_LIST:
        return {...state, selectedPresentations: []};
      case TOGGLE_SELECT_RENDER_PRODUCT:
        return applyToggleSelectRenderProduct(state, action);
      case RESET_SELECTED_RENDER_PRODUCT:
        return {...state, selectedRenderProducts: []};
      case UPDATE_SELECTED_RENDER_PRODUCT:
        return updateSelectedRenderProducts(state, action);
      default:
        return state;
    }
  
  };
  
  function applyToggleSelectPresentation(state, action) {
    const {id, isSelected} = action.payload;
    const selectedPresentations = id ? isSelected
      ? state.selectedPresentations.filter(itemId => itemId !== id)
      : state.selectedPresentations.concat(id) : state.selectedPresentations;
  
    return {...state, selectedPresentations};
  }
  
  function applyToggleAllPresentations(state) {
    let selectAll = state.selectedPresentations.length === 0;
    const selectedPresentations = selectAll
      ? state.presentationsList.map(c => c._id)
      : [];
    return {...state, selectedPresentations};
  }
  
  function setPresentationList(state, action) {
    const {presentationsList} = action.payload;
    return {...state, presentationsList};
  }
  
  function applyToggleSelectRenderProduct(state, action) {
    const {product, isSelected} = action.payload;
    const selectedRenderProducts = (product && product.renderedImages[0]) ? isSelected
      ? state.selectedRenderProducts.filter(itemId => (itemId.renderedImages && itemId.renderedImages[0]) !== (product && product.renderedImages[0]))
      : state.selectedRenderProducts.concat(product) : state.selectedRenderProducts;
  
    return {...state, selectedRenderProducts};
  }
  
  function updateSelectedRenderProducts(state, action) {
    const {selectedRenderProducts} = action.payload;
    return {...state, selectedRenderProducts};
  }